export const numberMasking = (phoneNumber) => {
    if (!phoneNumber) return '';

    const phoneStr = phoneNumber.toString();
    if (phoneStr.length >= 5) {
        const maskedPart = phoneStr.slice(-5);
        return "XXXXX" + maskedPart;
    } else {
        return phoneStr;
    }
};
